/** @format */

import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import moment from 'jalali-moment';

import Master from '../Layouts/Master';
import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { useAccess } from '../../Shared/hooks/useAccess';

const TicketDetail = () => {
  const { id } = useParams();
  const { canManageTickets } = useAccess();
  const isStaff = canManageTickets();
  const [loading, setLoading] = useState(true);
  const [ticket, setTicket] = useState(null);
  const [body, setBody] = useState('');
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    fetchTicket();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchTicket = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/tickets/${id}`,
      {},
      (res) => {
        setTicket(res.data?.data ?? null);
        setLoading(false);
      },
      () => {
        setLoading(false);
        error('دریافت تیکت با خطا مواجه شد');
      }
    );
  };

  const sendReply = async (e) => {
    e.preventDefault();
    if (!body.trim()) {
      return error('متن پیام الزامی است');
    }

    setActionLoading(true);
    await useApi.post(
      `/panel/tickets/${id}/reply`,
      { body: body.trim() },
      (res) => {
        success(res.data?.message || 'پاسخ ثبت شد');
        setTicket(res.data?.data ?? ticket);
        setBody('');
        setActionLoading(false);
      },
      (err) => {
        setActionLoading(false);
        error(err?.data?.message || 'ارسال پاسخ با خطا مواجه شد');
      }
    );
  };

  const closeTicket = async () => {
    setActionLoading(true);
    await useApi.put(
      `/panel/tickets/${id}/close`,
      {},
      (res) => {
        success(res.data?.message || 'تیکت بسته شد');
        setTicket(res.data?.data ?? ticket);
        setActionLoading(false);
      },
      (err) => {
        setActionLoading(false);
        error(err?.data?.message || 'بستن تیکت با خطا مواجه شد');
      }
    );
  };

  if (loading) {
    return <Loading />;
  }

  if (!ticket) {
    return (
      <Master>
        <p className="text-center my-5">تیکت یافت نشد</p>
      </Master>
    );
  }

  return (
    <Master>
      <div className="d-flex flex-row justify-content-between align-items-start border-bottom pb-3 my-3">
        <div>
          <Link
            to={isStaff ? '/panel/tickets/inbox' : '/panel/tickets'}
            className="f-12 text-muted d-block mb-2"
          >
            ← بازگشت
          </Link>
          <h1 className="text-secondary f-14 font-weight-bold mb-1">{ticket.subject}</h1>
          <span className={`badge ${ticket.status === 'closed' ? 'badge-secondary' : 'badge-success'}`}>
            {ticket.status_label}
          </span>
          {isStaff && ticket.owner && (
            <div className="f-12 text-muted mt-2">
              کاربر: {ticket.owner.name} — {ticket.owner.national_card_id}
            </div>
          )}
        </div>
        {ticket.can_close && (
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={closeTicket}
            disabled={actionLoading}
          >
            بستن تیکت
          </button>
        )}
      </div>

      <div className="card border shadow-sm mb-3">
        <div className="card-body" style={{ maxHeight: '420px', overflowY: 'auto' }}>
          {ticket.messages?.map((message) => (
            <div
              key={message.id}
              className={`mb-3 p-3 rounded ${
                message.is_staff_reply ? 'bg-light border' : 'bg-info text-white'
              }`}
              style={{ marginLeft: message.is_staff_reply ? '2rem' : 0, marginRight: message.is_staff_reply ? 0 : '2rem' }}
            >
              <div className="d-flex justify-content-between f-11 mb-2 opacity-75">
                <span>{message.author_name}</span>
                <span>
                  {moment(message.created_at).locale('fa').format('YYYY/MM/DD HH:mm')}
                </span>
              </div>
              <div className="f-13" style={{ whiteSpace: 'pre-wrap' }}>{message.body}</div>
            </div>
          ))}
        </div>
      </div>

      {ticket.can_reply ? (
        <form onSubmit={sendReply} className="card border shadow-sm p-3">
          <div className="form-group mb-2">
            <label className="f-13">پاسخ شما</label>
            <textarea
              className="form-control"
              rows={4}
              maxLength={5000}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-info btn-sm" disabled={actionLoading}>
            {actionLoading ? '...' : 'ارسال پاسخ'}
          </button>
        </form>
      ) : (
        <div className="alert alert-secondary f-13">این تیکت بسته شده است.</div>
      )}
    </Master>
  );
};

export default TicketDetail;
